import { MovieCogOutlineIcon } from './MovieCogOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 388C5417-3BC7-491F-B708-AD81DCB237C8
 * name movie-cog-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-cog-outline.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const FilmCogOutlineIcon = MovieCogOutlineIcon;
export default FilmCogOutlineIcon